import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { isAuthenticated } from '@/lib/auth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Il controllo e' asincrono perche' la sessione la conosce Supabase, non
 * localStorage: finche' non ha risposto non si puo' ne' mostrare il pannello
 * ne' rimbalzare al login, altrimenti un ricaricamento della pagina butterebbe
 * fuori un utente che invece e' autenticato.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [stato, setStato] = useState<'verifica' | 'dentro' | 'fuori'>('verifica')

  useEffect(() => {
    let annullato = false
    isAuthenticated().then((ok) => {
      if (!annullato) setStato(ok ? 'dentro' : 'fuori')
    })
    return () => {
      annullato = true
    }
  }, [])

  if (stato === 'verifica') return null
  if (stato === 'fuori') return <Navigate to="/admin/login" replace />
  return <>{children}</>
}
